import React, { Suspense, lazy } from 'react';

// Components
import Routes from '../../shared/Routes';
import { Generic } from '../../shared/Layouts';
import { ThemeProvider } from 'styled-components';
import { LangProvider } from '../../context/lang';
import { useVariables } from '../../context/variables';

// Utils
import { BrowserRouter as Router } from 'react-router-dom';
import GoogleRecaptchaWrapper from '../../shared/GoogleRecaptcha';

// Config
import routes from '../../config/routes';
import { useCheckUser } from '../../hooks/useCheckUser';
import { GlobalStyle } from '../../shared/GlobalStyle';
import { AccessibilityProvider } from '../../shared/AccessibilityToolbar';

const AccessibilityToolbar = lazy(() => import('../../shared/AccessibilityToolbar'));

const originalError = console.error;
const originalWarn = console.warn;

console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return;
  }
  originalError(...args);
};

console.warn = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed')) {
    return;
  }
  originalWarn(...args);
};

window.addEventListener('unhandledrejection', event => {
  if (event.reason && typeof event.reason.message === 'string' && event.reason.message.includes('reCAPTCHA')) {
    event.preventDefault();
  }
});

const App = () => {
  useCheckUser();

  const variables = { ...useVariables() };

  const children = (
    <LangProvider>
      <GoogleRecaptchaWrapper>
        <Router>
          <Generic>
            <Suspense fallback={<div>Loading...</div>}>
              <Routes routes={routes} />
            </Suspense>
          </Generic>
        </Router>
      </GoogleRecaptchaWrapper>
    </LangProvider>
  );

  const wrappedChildren = (
    <AccessibilityProvider>
      <Suspense fallback={null}>
        <AccessibilityToolbar />
      </Suspense>
      <div id="zoom-wrapper">
        {children}
      </div>
    </AccessibilityProvider>
  );

  return variables ? (
    <ThemeProvider theme={variables}>
      <GlobalStyle />
      {wrappedChildren}
    </ThemeProvider>
  ) : (
    wrappedChildren
  );
};

export default App;
